export const CountriesData = [
  {
    countryCode: "AUT",
    countryName: "Austria",
    twoDigitCountryCode: "AT",
    currencyCode: "EUR",
    languageCode: "de-AT",
    companyCode: "1086",
    region: "EMEA",
  },
  {
    countryCode: "BEL",
    twoDigitCountryCode: "BE",
    countryName: "Belgium",
    currencyCode: "EUR",
    languageCode: "nl-BE",
    companyCode: "1082",
    region: "EMEA",
  },
  {
    countryCode: "DNK",
    twoDigitCountryCode: "DK",
    countryName: "Denmark",
    currencyCode: "DKK",
    languageCode: "da-DK",
    companyCode: "1023",
    region: "EMEA",
  },
  {
    countryCode: "FRA",
    twoDigitCountryCode: "FR",
    countryName: "France",
    currencyCode: "EUR",
    languageCode: "fr-FR",
    companyCode: "1073",
    region: "EMEA",
  },
  {
    countryCode: "DEU",
    twoDigitCountryCode: "DE",
    countryName: "Germany",
    currencyCode: "EUR",
    languageCode: "de-DE",
    companyCode: "1072",
    region: "EMEA",
  },
  {
    countryCode: "IRL",
    twoDigitCountryCode: "IE",
    countryName: "Ireland",
    currencyCode: "EUR",
    languageCode: "en-IE",
    companyCode: "1062",
    region: "EMEA",
  },
  {
    countryCode: "ITA",
    twoDigitCountryCode: "IT",
    countryName: "Italy",
    currencyCode: "EUR",
    languageCode: "it-IT",
    companyCode: "1078",
    region: "EMEA",
  },
  {
    countryCode: "JPN",
    twoDigitCountryCode: "JP",
    countryName: "Japan",
    currencyCode: "JPY",
    languageCode: "ja-JP",
    companyCode: "1079",
    region: "Japan",
  },
  {
    countryCode: "LUX",
    twoDigitCountryCode: "LU",
    countryName: "Luxembourg",
    currencyCode: "EUR",
    languageCode: "lb-LU",
    companyCode: "1062",
    region: "EMEA",
  },
  {
    countryCode: "NLD",
    twoDigitCountryCode: "NL",
    countryName: "Netherlands",
    currencyCode: "EUR",
    languageCode: "nl-NL",
    companyCode: "1052",
    region: "EMEA",
  },
  {
    countryCode: "NZL",
    twoDigitCountryCode: "NZ",
    countryName: "New Zealand",
    currencyCode: "NZD",
    languageCode: "en-NZ",
    companyCode: "1083",
    region: "APAC",
  },
  {
    countryCode: "NOR",
    twoDigitCountryCode: "NO",
    countryName: "Norway",
    currencyCode: "NOK",
    languageCode: "no-NO",
    companyCode: "1025",
    region: "EMEA",
  },
  {
    countryCode: "PRT",
    twoDigitCountryCode: "PT",
    countryName: "Portugal",
    currencyCode: "EUR",
    languageCode: "pt-PT",
    companyCode: "1085",
    region: "EMEA",
  },
  {
    countryCode: "SGP",
    twoDigitCountryCode: "SG",
    countryName: "Singapore",
    currencyCode: "SGD",
    languageCode: "en-SG",
    companyCode: "1290",
    region: "APAC",
  },
  {
    countryCode: "ESP",
    twoDigitCountryCode: "ES",
    countryName: "Spain",
    currencyCode: "EUR",
    languageCode: "es-ES",
    companyCode: "1053",
    region: "EMEA",
  },
  {
    countryCode: "SWE",
    twoDigitCountryCode: "SE",
    countryName: "Sweden",
    currencyCode: "SEK",
    languageCode: "sv-SE",
    companyCode: "1077",
    region: "EMEA",
  },
  {
    countryCode: "CHE",
    twoDigitCountryCode: "CH",
    countryName: "Switzerland",
    currencyCode: "CHF",
    languageCode: "de-CH",
    companyCode: "1054",
    region: "EMEA",
  },
  {
    countryCode: "FIN",
    twoDigitCountryCode: "FI",
    countryName: "Finland",
    currencyCode: "EUR",
    languageCode: "fi-FI",
    companyCode: "1024",
    region: "EMEA",
  },
];

export const CountriesOptions = [
  {
    key: "Austria",
    text: "Austria",
  },

  {
    key: "Belgium",
    text: "Belgium",
  },

  {
    key: "Denmark",
    text: "Denmark",
  },
  {
    key: "France",
    text: "France",
  },
  {
    key: "Germany",
    text: "Germany",
  },
  {
    key: "Ireland",
    text: "Ireland",
  },
  {
    key: "Italy",
    text: "Italy",
  },
  {
    key: "Japan",
    text: "Japan",
  },
  {
    key: "Luxembourg",
    text: "Luxembourg",
  },
  {
    key: "Netherlands",
    text: "Netherlands",
  },
  {
    key: "New Zealand",
    text: "New Zealand",
  },
  {
    key: "Norway",
    text: "Norway",
  },
  {
    key: "Portugal",
    text: "Portugal",
  },
  {
    key: "Singapore",
    text: "Singapore",
  },
  {
    key: "Spain",
    text: "Spain",
  },
  {
    key: "Sweden",
    text: "Sweden",
  },
  {
    key: "Switzerland",
    text: "Switzerland",
  },
  {
    key: "Finland",
    text: "Finland",
  },
];

export const allCountries = [
  {
    key: "Austria",
    text: "Austria",
  },

  {
    key: "Belgium",
    text: "Belgium",
  },
  {
    key: "Denmark",
    text: "Denmark",
  },
  {
    key: "France",
    text: "France",
  },
  {
    key: "Germany",
    text: "Germany",
  },
  {
    key: "Ireland",
    text: "Ireland",
  },
  {
    key: "Italy",
    text: "Italy",
  },
  {
    key: "Japan",
    text: "Japan",
  },
  {
    key: "Luxembourg",
    text: "Luxembourg",
  },
  {
    key: "Netherlands",
    text: "Netherlands",
  },
  {
    key: "New Zealand",
    text: "New Zealand",
  },
  {
    key: "Norway",
    text: "Norway",
  },
  {
    key: "Portugal",
    text: "Portugal",
  },
  {
    key: "Singapore",
    text: "Singapore",
  },
  {
    key: "Spain",
    text: "Spain",
  },
  {
    key: "Sweden",
    text: "Sweden",
  },
  {
    key: "Switzerland",
    text: "Switzerland",
  },
  {
    key: "Finland",
    text: "Finland",
  },
];

export const remittanceCurrencyCodeAndCompanyCodeCountries=["sweden","norway","denmark","switzerland","finland","spain","italy","netherlands"];
export const BELGIUM = "Belgium";
export const AUSTRIA = "Austria";